import { useValidationErrorModal } from 'clientState/providers/ValidationErrorModalProvider/ValidationErrorModalProvider';
import { useEffect } from 'react';

export type GraphQlError<ClientErrorResult> = ClientErrorResult & {
  extensions?: {
    errorCode?: string | null;
    errorData?: Record<string, unknown> | null;
  };
  message?: string | null;
};

export type OperationResult<ClientResult, ClientErrorResult> = ClientResult & {
  errors?: Array<GraphQlError<ClientErrorResult>> | null;
  httpStatusCode?: number;
  operationName?: string;
};
export const VALIDATION_SEARCH_ERROR = 'SEARCH_ENGINE_VALIDATION_ERROR';
const isValidationError = (errors) => {
  return errors?.some(
    (error) => error.extensions?.errorCode === VALIDATION_SEARCH_ERROR
  );
};

export const useFrontendApiValidationError = <ClientResult, ClientErrorResult>(
  result: OperationResult<ClientResult, ClientErrorResult>
) => {
  const { errors } = result || {};
  const [, setIsOpen] = useValidationErrorModal();

  useEffect(() => {
    if (isValidationError(errors)) {
      setIsOpen(true);
    }
  }, [errors, setIsOpen]);
};
